import React, { useCallback, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import StatusPage from '../StatusPage/StatusPage';
import CancelMonitoringModal from '../CancelMonitoringModal/CancelMonitoringModal';
import { PrimaryButton } from '../../../CommonComponents/Button';
import LinkButton from '../LinkButton/LinkButton';
import { Actions } from './WorkflowLandingStyles';
import { setSubscriberEnrolling } from '../../ExperianActions';
import ExperianContext from '../../ExperianContext';

const WorkflowLanding = () => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const { subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();
  const setSubscriberEnrollingCallback = useCallback(
    () => dispatch(setSubscriberEnrolling(subscriberId)),
    [subscriberId, dispatch],
  );

  return (
    <>
      <StatusPage icon="fas fa-bed" accentColor="#e1f2fe">
        Your enrollment is currently in progress.
        <Actions>
          <PrimaryButton onClick={setSubscriberEnrollingCallback}>
            Continue Application
          </PrimaryButton>
          <LinkButton onClick={() => setIsCancelModalOpen(true)}>Cancel my enrollment</LinkButton>
        </Actions>
      </StatusPage>
      <CancelMonitoringModal
        isOpen={isCancelModalOpen}
        onRequestClose={() => setIsCancelModalOpen(false)}
      />
    </>
  );
};

export default WorkflowLanding;
